import { Lock } from "lucide-react";
import { idr } from "../../../lib/api";

// Brief 22 Sep 2026 A9: "Setelah Program dinyatakan SELESAI oleh PIC, Total Support
// Aktivasi & Cashback langsung muncul pada dashboard Program Price Protection."
// Angkanya dari SNAPSHOT yang disetujui PIC, dijumlah backend per jenis × kanal
// (`GET /cashback/dashboard` → `program_selesai.kelompok`) — layar tidak
// menjumlahkan ulang apa pun.
export default function DashboardProgramSelesai({ data }) {
  const kelompok = (data && data.kelompok) || [];
  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-5 space-y-3" data-testid="cb-dash-selesai">
      <div className="flex items-center gap-2">
        <Lock className="w-4 h-4 text-indigo-600" />
        <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Program Selesai (disetujui PIC)</p>
      </div>
      {kelompok.length === 0 ? (
        <p className="text-sm text-slate-500" data-testid="cb-dash-selesai-kosong">Belum ada program yang dinyatakan Selesai.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {kelompok.map((g) => (
            <div key={`${g.jenis}-${g.kanal}`} data-testid={`cb-dash-selesai-${g.jenis}-${g.kanal}`}
                 className="border border-indigo-100 bg-indigo-50/40 rounded-lg p-4">
              <p className="text-xs font-semibold text-slate-800">{g.label}</p>
              <p className="font-display text-xl font-bold text-indigo-700 mt-1">{idr(g.total_hak)}</p>
              <p className="text-[11px] text-slate-500">Total hak · {g.unit_hak} unit · {g.program} program</p>
              <div className="flex flex-wrap gap-x-4 gap-y-1 mt-2 text-[11px] text-slate-600">
                <span>Uang diterima <b className="text-slate-800">{idr(g.uang_diterima)}</b></span>
                <span>Dilepas (hangus) <b className="text-rose-700">{idr(g.hak_dilepas)}</b> · {g.unit_dilepas} unit</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
